import React from "react";
// import checkTik from "assets/images/wareHouse-icons/tick-icon.svg";

import "./PreFaktorPrintFooter.scss";
import useAxios from "middleware/useAxios";
const PreFaktorPrintFooter = () => {
  const [prefactorFooterItems] = useAxios({
    method: "GET",
    url: "/footer",
  });

  return prefactorFooterItems ? (
    <div className="prefaktor-print-footer-container">
      <ul>
        {prefactorFooterItems.map((item) => {
          return (
            <li>
              {/* <img src={checkTik} alt="" /> */}
              {item.description}
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};

export default PreFaktorPrintFooter;
